import { useEffect, useLayoutEffect, useRef } from 'react';
import { useIsomorphicLayoutEffect } from './use-isomorphic-layout-effect';
export const getTarget = target => {
  if (!(typeof window !== 'undefined' && window.document)) return undefined;
  if (!target) return undefined;
  if (typeof target === 'function') return target();
  if ('current' in target) return target.current;
  return target;
};
const depsAreSame = (oldDeps, deps) => {
  if (oldDeps === deps) return true;
  for (let i = 0; i < oldDeps.length; i++) {
    if (!Object.is(oldDeps[i], deps[i])) {
      return false;
    }
  }
  return true;
};
export const createEffectWithTarget = useEffectType => {
  const useEffectWithTarget = (effect, deps, target) => {
    const cleanupRef = useRef();
    const hasInitRef = useRef(false);
    const prevElements = useRef([]);
    const prevDeps = useRef([]);
    useEffectType(() => {
      const targets = Array.isArray(target) ? target : [target];
      const elements = targets.map(target => getTarget(target));
      if (!hasInitRef.current) {
        hasInitRef.current = true;
        prevDeps.current = deps;
        prevElements.current = elements;
        cleanupRef.current = effect();
        return;
      }
      if (elements.length !== prevElements.current.length || !depsAreSame(elements, prevElements.current) || !depsAreSame(deps, prevDeps.current)) {
        cleanupRef.current == null || cleanupRef.current();
        cleanupRef.current = effect();
        prevDeps.current = deps;
        prevElements.current = elements;
      }
    });
    useEffect(() => () => {
      cleanupRef.current == null || cleanupRef.current();
      hasInitRef.current = false;
    }, []);
  };
  return useEffectWithTarget;
};
export const useEffectWithTarget = createEffectWithTarget(useEffect);
export const useLayoutEffectWithTarget = createEffectWithTarget(useLayoutEffect);
export const useIsomorphicLayoutEffectWithTarget = createEffectWithTarget(useIsomorphicLayoutEffect);